import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";
import { telemetryDrivingEventTypeSchema } from "../_shared";

export const tripsBuilderEcoDrivingByVinResponseSchema = z
  .object({
    vin: vinSchema,
    score: z.number(),
    events: z.array(
      z.object({
        start_date: z.iso.datetime(),
        end_date: z.iso.datetime(),
        value: z.number(),
        unit: z.string(),
        event_type: telemetryDrivingEventTypeSchema,
      }),
    ),
    harsh_accelerations_count: z.number().nullable(),
    harsh_brakes_count: z.number().nullable(),
    sharp_turns_count: z.number().nullable(),
  })
  .nullable();

export type TripsBuilderEcoDrivingByVinResponse = z.infer<
  typeof tripsBuilderEcoDrivingByVinResponseSchema
>;
